
import { playHotspotAudio, isAudioPlaying } from './playAudio.js';

export function initializeTippy() {
    const hotspotElements = document.querySelectorAll('.tooltip-trigger');

    hotspotElements.forEach(hotspotButton => {
        const textElement = hotspotButton.parentElement.querySelector('.ggskin_text');

        if (!textElement) {
            console.warn("Tooltip: Could not find associated text element:", hotspotButton);
            return;
        }

        const tooltipContent = textElement.innerHTML;
        
        // Process the content to transform audio spans into playable buttons
        const processedContent = processAudioSpans(tooltipContent);

        tippy(hotspotButton, {
            content: processedContent,
            allowHTML: true,
            theme: 'my-theme',
            maxWidth: '80vw',
            minWidth: '500px',
            interactive: true,
            trigger: 'mouseenter focus',
            placement: 'top',
            arrow: true,
            animation: 'fade',
            duration: [800, 1600],
            onCreate(instance) {
                instance.popper.classList.add('animate__animated');
            },
            onShow(instance) {
                tippy.hideAll({ exclude: instance });
                instance.popper.classList.remove('animate__hinge');
                instance.popper.classList.add('animate__bounceIn');
                
                // Hide all other tooltip triggers except the current one
                hotspotElements.forEach(element => {
                    if (element !== instance.reference) {
                        element.style.opacity = '0.05';
                        element.style.pointerEvents = 'none';
                    }
                });
                
                // Add click handlers to audio buttons after tooltip appears
                setTimeout(() => {
                    const audioButtons = instance.popper.querySelectorAll('.audio-play-button');
                    audioButtons.forEach(button => {
                        const audioPath = button.dataset.audioPath;
                        const audioTitle = button.dataset.audioTitle || "Audio Narration";
                        
                        // Check if this is the current playing audio and update button state
                        if (isAudioPlaying() && currentAudio && currentAudio.src.endsWith(audioPath)) {
                            button.innerHTML = '<i class="fa fa-pause"></i>';
                            button.classList.add('playing');
                        }
                        
                        button.addEventListener('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            playHotspotAudio(audioPath, button, audioTitle);
                        });
                    });
                }, 100);
            },
            onHide(instance) {
                instance.popper.classList.remove('animate__bounceIn');
                instance.popper.classList.add('animate__hinge');
                
                // Show all tooltip triggers again
                hotspotElements.forEach(element => {
                    element.style.opacity = '';
                    element.style.pointerEvents = '';
                });
                
                // Don't stop audio when tooltip hides
                // stopAllAudio(); - Remove this line!
            },
            onHidden(instance) {
                instance.popper.classList.remove('animate__hinge');
            },
            // Rest of your Tippy.js configuration...
        });
    });
}

// Helper function to process audio spans
function processAudioSpans(html) {
    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Find all audio file spans
    const audioSpans = tempDiv.querySelectorAll('.audio-file');
    
    audioSpans.forEach(span => {
        // Get the audio path and optional title
        const audioPath = span.textContent.trim();
        const audioTitle = span.getAttribute('data-title') || '';
        
        // Create play button
        const playButton = document.createElement('button');
        playButton.className = 'audio-play-button';
        playButton.setAttribute('data-audio-path', audioPath);
        playButton.setAttribute('data-audio-title', audioTitle);
        playButton.innerHTML = '<i class="fa fa-play"></i>';
        
        // Replace the span with the button
        span.parentNode.replaceChild(playButton, span);
    });
    
    return tempDiv.innerHTML;
}